import React, { Component } from 'react';
import Translator from './../../../requests/apa/Translator';
import Assets from './../../../requests/apa/Asset';
import api from './../../requests/api/';
import Device from '../../../devices/device';
import { RouteComponentProps } from 'react-router-dom';
import './_styles.scss';
import { Player } from '../VcardTeam/player';
import Utils from 'src/utils/Utils';
import Asset from './../../../requests/apa/Asset';
class VcardPlayer extends Component<RouteComponentProps> {
    constructor(props: any) {
        super(props);
        this.onKeyPress = this.onKeyPress.bind(this);
    }
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    state = {
        imgBackground: null,
        iconPosition: null,
        iconJersery: null,
        iconTeam: null,

        playerData: {
            positionName: '',
            playerImage: '',
            playerName: '',
            uniformNumber: '',
            dateOfBirth: '',
            nationality: '',
            nationalityAbbrev: ''
        },
        apaData: {
            placeBirthText: '',
            positionText: '',
            jerseryText: '',
            selectionText: '',
            textDetails: '',
        },

        teamData: {
            teamName: '',
            teamFlag: '',
        },
    };

    onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'BACK') {
            const { history } = this.props;
            history.goBack();
        }
    }

    private getApaData() {
        this.setState({
            apaData: {
                placeBirthText: Translator.get(
                    'talent_detail_placeBirth_label',
                    'Lugar de Nacimiento'
                ),
                positionText: Translator.get('talent_player_detail_position_label', 'posición'),
                jerseryText: Translator.get(
                    'talent_player_detail_jersey_label',
                    'no. de camiseta selección'
                ),
                selectionText: Translator.get('talent_player_detail_selection_label', 'selección'),
                textDetails: Translator.get(
                    'talent_player_detail_title_label',
                    'Detalles del jugador'
                ),
            },
        });
    }

    private async getPlayerData() {
        const {
            match: {
                params: { teamId, playerId },
            },
        } = this.props;
        const data = await api.getPlayer(teamId, playerId);
        
        if (data.player && data.team) {
            const { name, image, positionName, dateOfBirth, uniformNumber, nationality, nationalityAbbrev} = data.player;
            const { name: teamName, flag } = data.team;

            this.setState({
                playerData: {
                    positionName,
                    playerImage: image,
                    uniformNumber,
                    playerName: name,
                    dateOfBirth,
                    nationality,
                    nationalityAbbrev,
                },
                teamData: {
                    teamName,
                    teamFlag: flag,
                },
            });
        }
    }

    componentDidMount() {
        this.getPlayerData();
        this.getApaData();
        document.querySelector('.player-main-container')?.scrollIntoView();
        Utils.setInitialFocus('#player-name')
        document.addEventListener('keydown', this.onKeyPress, true);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyPress, true);
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.match.params.playerId !== prevProps.match.params.playerId) {
            this.getPlayerData();
            Utils.setInitialFocus('#player-name')
        }
    }

    private imgBackground() {
        const urlImg = Assets.get('talent_player_detail_header_img');
        return <img src={urlImg} alt={urlImg} />;
    }

    private getIcon(label: string) {
        const urlImg = Assets.get(label);
        return <img src={urlImg} alt={label} />;
    }

    private transformImg() {
        document.querySelector('.fade-div')?.classList.add('fade-class')
        document.querySelector('.fade-class')?.scrollIntoView();
        document.querySelector('.player-gradient')?.classList.remove('gradient-bottom-players-related')
        document.querySelector('.player-gradient')?.classList.add('gradient-center-players-related')
        document.querySelector('.second-container')?.style.zIndex='0'
    }


    private removeFade () {
        document.querySelector('.fade-div')?.classList.remove('fade-class')
        document.querySelector('.vcard-soccer-players')?.scrollIntoView();
        document.querySelector('.player-gradient')?.classList.remove('gradient-center-players-related')
        document.querySelector('.player-gradient')?.classList.add('gradient-bottom-players-related')
        document.querySelector('.second-container')?.style.zIndex='2'
    }

    public render(): React.ReactNode {
        const {
            placeBirthText,
            positionText,
            jerseryText,
            selectionText,
            textDetails,
        } = this.state.apaData;

        const { positionName, playerName, playerImage, dateOfBirth, uniformNumber, nationality, nationalityAbbrev } = this.state.playerData;

        const { teamName, teamFlag } = this.state.teamData;

        const { teamId, playerId } = this.props.match.params;

        const ribbonData = {
            idTeam: teamId,
            title: Translator.get('talent_player_detail_title_ribbon_players_label'),
            idPlayer: playerId,
        };

        const coverImageStyles = {
            backgroundImage: `url(${playerImage})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
        }

        return (
            <div className="player-main-container" style={{ backgroundImage: `url(${Assets.get('talent_player_detail_header_img')})` }}>
                <div className="cont-img">
                    <div className="box-img">
                        <a
                            data-sn-left=''
                            href=""
                            id="player-name"
                            className="focusable"
                            onFocus={this.transformImg}
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            target="_blank"
                        >
                            {playerImage &&  
                                <button 
                                    className="img-focusable" 
                                    style={coverImageStyles}
                                    onClick={(e) => {
                                        e.preventDefault();
                                    }}>
                                </button>
                            }
                        </a>
                    </div>
                    <div className="name">
                        <span>{playerName}</span>
                    </div>
                    {dateOfBirth !== '' &&
                        (
                            <div className="place-birth">
                                <span className="place-birth_title">{`${placeBirthText}`}</span>
                                <span className="place-birth_value">{` ${dateOfBirth}`}</span>
                            </div>
                        )
                    }
                    <div className="team">
                        <span className="team_abr">{`${nationalityAbbrev} `}</span>
                        <span className="team_value">{` | ${nationality}`}</span>
                    </div>
                </div>
                <div className="second-container">
                    <div
                        className="title-details-player focusable"
                        tabIndex={0}
                        data-sn-up="#player-name"
                        onFocus={this.removeFade}
                    >
                        <span>{textDetails}</span>
                    </div>
                    <div className="details-player">
                        <div>
                            <div className="detail-type">{positionText}</div>
                            <div className="detail-item">
                                <div className="detail-icon">
                                    {this.getIcon('talent_player_detail_position_img')}
                                </div>
                                <div className="detail-text">{positionName}</div>
                            </div>
                        </div>
                        <div>
                            <div className="detail-type">{jerseryText}</div>
                            <div className="detail-item">
                                <div className="detail-icon">
                                    {this.getIcon('talent_player_detail_jersey_img')}
                                </div>
                                <div className="detail-text">{uniformNumber}</div>
                            </div>
                        </div>
                        <div>
                            <div className="detail-type">{selectionText}</div>
                            <div className="detail-item">
                                <div className="detail-icon_flag">
                                    <img src={teamFlag || Asset.get('flag_team_placeholder_img')} alt="" width="37px" height="37px" />
                                </div>
                                <div className="detail-text">{teamName}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='soccer-player'>
                    <Player playerData={ribbonData} {...this.props} />
                </div>
                <div className='fade-div fade-class'></div>
                <div className='player-gradient gradient-center-players-related'/>
                <div className='black-space'></div>
            </div>
        );
    }
}

export default VcardPlayer;



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardPlayer/index.tsx